import { useStore } from '@nanostores/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NoDatabaseScreen } from '~/components/ui/shadcn/components/supabase-manager/NoDatabaseScreen';
import { SecretsManager } from '~/components/ui/shadcn/components/supabase-manager/Secrets.client';
import { supabaseStore } from '~/lib/stores/supabase';

const queryClient = new QueryClient();

export const Secrets = () => {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);
  const project = useStore(supabaseStore.supabaseProject);
  const projectId = project?.id;

  if (supabaseStatus !== 'CONFIGURED' || !projectId) {
    return (
      <NoDatabaseScreen icon="i-lucide:key-round" description="You need a database to view and manage your secrets." />
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <SecretsManager />
    </QueryClientProvider>
  );
};
